import { useQuery, useMutation } from '@tanstack/react-query';
import type { TableInfo, QueryResult } from '../api/admin-sql';
import * as adminSqlApi from '../api/admin-sql';

export function useTableSchema() {
  return useQuery<TableInfo[]>({
    queryKey: ['admin-sql-tables'],
    queryFn: () => adminSqlApi.getTableSchema(),
    staleTime: 5 * 60 * 1000, // 5 minutes
  });
}

export function useExecuteQuery() {
  return useMutation<QueryResult, Error, string>({
    mutationFn: (sql: string) => adminSqlApi.executeQuery(sql),
  });
}
